import { createStyledContext } from "@tamagui/core";
const RadioGroupStyledContext = createStyledContext({
  size: "$true",
  scaleIcon: 1
});
export { RadioGroupStyledContext };
//# sourceMappingURL=RadioGroupStyledContext.mjs.map
